<script setup>
const props = defineProps({
  animate: {
    default: true,
    type: Boolean,
  },
  color: {
    default: 'indigo',
    type: String,
    validator: value => [
      'blue',
      'indigo',
      'purple',
    ].includes(value),
  },
  duration: {
    default: 6000,
    type: Number,
  },
  hoverable: {
    default: true,
    type: Boolean,
  },
  opacity: {
    default: 0.6,
    type: Number,
  },
  spread: {
    default: 8,
    type: Number,
  },
})

const animateClass = computed(() => {
  return props.animate ? 'animate-rotate' : ''
})

const borderColorClass = computed(() => {
  return `b-${props.color}`
})
</script>

<template>
  <div
    class="glow-wrapper group/animated-border relative flex"
    :style="{ '--duration': `${duration}ms` }"
  >
    <div
      class="inert translate pointer-events-none absolute -inset-px -z-10 transform-gpu rounded-xl opacity-60 transition-all will-change-auto"
      :class="[animateClass, borderColorClass, { 'group-hover/animated-border:-inset-1 group-hover/animated-border:opacity-70': hoverable }]"
      inert
      :style="{
        backgroundSize: '200% 100%',
        filter: `blur(${spread}px)`,
        transitionDuration: `200ms`,
        opacity,
      }"
    />

    <slot />
  </div>
</template>

<style scoped lang="postcss">
@keyframes rotate {
  0% {
    background-position: 0% 50%;
  }
  100% {
    background-position: 200% 50%;
  }
}

.animate-rotate {
  animation: rotate var(--duration) linear infinite;
}

.b-indigo {
  background: linear-gradient(90deg, #6366F1, #4338CA, #818CF8);
}

.b-purple {
  background: linear-gradient(90deg, #A855F7, #7E22CE, #C084FC);
}

.b-blue {
  background: linear-gradient(90deg, #3B82F6, #1D4ED8, #93C5FD);
}

/* Dark mode variants */
html.dark {
  .b-indigo {
    background: linear-gradient(90deg, #6366F1, #4338CA, #818CF8);
  }
  .b-purple {
    background: linear-gradient(90deg, #E9D5FF, #D8B4FE, #F3E8FF);
  }
  .b-blue {
    background: linear-gradient(90deg, #BFDBFE, #93C5FD, #DBEAFE);
  }
}
</style>
